export default "__VITE_ASSET__CybMDbBj__"